module.exports = __webpack_public_path__ + "static/flail_snail-af1668b31d1d3165b0fca0bd242c4802.jpeg";